import { ServerListActions } from 'actions';

/** Value list name (ForceManager /values API). */
export const MARKETING_STATUS_LIST = 'tblMarketingStatus';

/** Canonical ids from tblMarketingStatus (must match backend /values). */
export const MARKETING_STATUS = {
    NO_CONSENT: 1,
    SUBSCRIBED: 2,
    CANCELED: 3,
};

export function fetchMarketingStatusList(dispatch) {
    return dispatch(ServerListActions.getList(MARKETING_STATUS_LIST));
}

/**
 * Resolves an id from tblMarketingStatus. Throws if the list is empty or the id is absent.
 */
export function resolveMarketingStatusIdFromList(rows, expectedId) {
    if (!Array.isArray(rows) || rows.length === 0) {
        throw new Error('tblMarketingStatus: empty value list');
    }
    const match = rows.find((r) => Number(r.value ?? r['-id']) === expectedId);
    if (match == null) {
        throw new Error(`tblMarketingStatus: id ${expectedId} not found`);
    }
    return Number(match.value ?? match['-id']);
}

function getKnownChipVisual(id, theme) {
    const presets = {
        [MARKETING_STATUS.NO_CONSENT]: {
            bgColor: theme.colors.background.utility025,
            hoverBgColor: theme.colors.actionMinor[150],
            borderColor: theme.colors.actionMinor[200],
            openBorderColor: theme.colors.actionMinor[600],
            textColor: theme.colors.actionMinor[600],
            iconColor: theme.colors.actionMinor[600],
            iconBgColor: theme.colors.background.utility025,
            iconType: 'withoutConsent',
        },
        [MARKETING_STATUS.SUBSCRIBED]: {
            bgColor: theme.fn.alpha(theme.colors.semantic.positiveCustom100, 0.5),
            hoverBgColor: theme.colors.semantic.positiveCustom100,
            borderColor: theme.colors.semantic.positiveCustom200,
            openBorderColor: theme.colors.semantic.positive200,
            textColor: theme.colors.semantic.positive500,
            iconColor: theme.colors.semantic.positive500,
            iconBgColor: theme.colors.semantic.positiveCustom100,
            iconType: 'personCheck',
        },
        [MARKETING_STATUS.CANCELED]: {
            bgColor: theme.fn.alpha(theme.colors.semantic.caution100, 0.5),
            hoverBgColor: theme.colors.semantic.caution100,
            borderColor: theme.colors.semantic.caution200,
            openBorderColor: theme.colors.semantic.caution200,
            textColor: theme.colors.semantic.caution600,
            iconColor: theme.colors.semantic.caution600,
            iconBgColor: theme.colors.caution100,
            iconType: 'personCancel',
        },
    };
    return presets[id];
}

/**
 * Maps /values rows to SelectChipStates options (label + styling).
 */
export function buildMarketingStatusChipOptions(rows, theme) {
    if (!Array.isArray(rows) || rows.length === 0) return [];
    return rows.map((item) => {
        const id = Number(item.value ?? item['-id']);
        const visual = getKnownChipVisual(id, theme) ?? {};
        return {
            label: item.label,
            value: id,
            ...visual,
        };
    });
}

/**
 * Prefer tblMarketingStatus label/styling; fall back to API MarketingStatus text.
 * @param {{ MarketingStatusId: number, MarketingStatus?: string }} entry
 * @param {ReturnType<typeof buildMarketingStatusChipOptions>} statusOptions
 * @param {import('@Sage/hoi-poi-ui').Theme} [theme]
 */
export function resolveHistoryStatusOption(entry, statusOptions, theme) {
    const matched = statusOptions.find((option) => option.value === entry.MarketingStatusId);
    if (matched) {
        return matched;
    }
    if (!entry.MarketingStatus) {
        return undefined;
    }
    const visual = theme ? (getKnownChipVisual(entry.MarketingStatusId, theme) ?? {}) : {};
    return {
        label: entry.MarketingStatus,
        value: entry.MarketingStatusId,
        ...visual,
    };
}
